export default __webpack_public_path__ + "static/media/Badge10.ce2cfe23.png";